import type { components } from "@/api/types";

export type ActivityItem = components["schemas"]["ActivityItem"];
export type ActivityType = components["schemas"]["ActivityType"];
export type ActivityFilter = components["schemas"]["ActivityFilter"];

const TYPES = new Set<string>([
  "robot_purchased",
  "daily_result",
  "ai_decision",
  "deposit",
  "withdrawal",
  "referral",
]);

/** Незнакомый тип события не должен ронять ленту — он рисуется нейтрально. */
export function asActivityType(value: string): ActivityType | null {
  return TYPES.has(value) ? (value as ActivityType) : null;
}

/**
 * `payload` в контракте — свободный JSON (`Record<string, unknown>`), поэтому
 * достаём поля по одному и с проверкой типа. Ключи описаны в BE-07:
 *   daily_result   → user_robot_id, date, percent, amount
 *   ai_decision    → user_robot_id, date
 *   deposit        → deposit_id, status
 *   withdrawal     → withdrawal_id, status, refunded?
 *   referral       → invitee_id
 */
export function payloadNumber(payload: unknown, key: string): number | undefined {
  const value = (payload as Record<string, unknown> | undefined)?.[key];
  return typeof value === "number" ? value : undefined;
}

export function payloadString(payload: unknown, key: string): string | undefined {
  const value = (payload as Record<string, unknown> | undefined)?.[key];
  return typeof value === "string" ? value : undefined;
}
